import { render, staticRenderFns } from "./alertAssistant_teacher3_licence.vue?vue&type=template&id=cdd9f220&scoped=true&"
import script from "./alertAssistant_teacher3_licence.vue?vue&type=script&lang=js&"
export * from "./alertAssistant_teacher3_licence.vue?vue&type=script&lang=js&"
import style0 from "./alertAssistant_teacher3_licence.vue?vue&type=style&index=0&id=cdd9f220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd9f220",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VChip,VCol,VIcon,VRow})
